import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useAuthStore from '../store/auth';

export default function VerifyEmailPending() {
  const { t } = useTranslation();
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'radial-gradient(ellipse 80% 60% at 50% -10%,#2d1f7a44,transparent),var(--bg)', padding:20 }}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:24, padding:48, width:'100%', maxWidth:460, textAlign:'center', boxShadow:'0 40px 80px #00000060' }}>
        <div style={{ fontSize:72, marginBottom:20 }}>📧</div>
        <div style={{ fontFamily:'Syne,sans-serif', fontSize:22, fontWeight:800, marginBottom:8 }}>{t('verify_email_title')}</div>
        <p style={{ color:'var(--text2)', fontSize:15, lineHeight:1.8, marginBottom:12 }}>
          {t('verify_email_msg')}
        </p>
        <div style={{ background:'#7c6af720', border:'1px solid #7c6af740', borderRadius:12, padding:'12px 16px', marginBottom:28, fontSize:15, color:'var(--accent)', fontWeight:600 }}>
          {user?.email}
        </div>
        <div style={{ background:'var(--surface2)', border:'1px solid var(--border)', borderRadius:12, padding:16, marginBottom:28, fontSize:13, color:'var(--text2)', textAlign:'left' }}>
          <div style={{ marginBottom:6, fontWeight:600 }}>Vous ne trouvez pas l&apos;email ?</div>
          <ul style={{ margin:0, paddingLeft:20, lineHeight:2 }}>
            <li>Verifiez votre dossier spams</li>
            <li>L&apos;email peut prendre 2-3 minutes</li>
            <li>Verifiez que l&apos;adresse est correcte</li>
          </ul>
        </div>
        <button onClick={handleLogout} style={{ width:'100%', padding:14, background:'var(--surface2)', color:'var(--text2)', border:'1px solid var(--border)', borderRadius:10, fontFamily:'Syne,sans-serif', fontWeight:600, fontSize:14 }}>
          Se connecter avec un autre compte
        </button>
      </div>
    </div>
  );
}